import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnInit {

  @Input() public bgClass: string = "bg-primary";
  @Input() public firstLabel: string = "";
  @Input() public secondLabel: string = "";
  @Input() public currentPercent: number = 50;
  @Input() public minPercent: number = 0;
  @Input() public maxPercent: number = 100;
  constructor() { }

  ngOnInit() {
  }

}


// WEBPACK FOOTER //
// ./src/app/components/tools/progress-bar/progress-bar.component.ts